"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var Cell_less_1 = __importDefault(require("./Cell.less"));
var framer_motion_1 = require("framer-motion");
var Cell = function (_a) {
    var _b;
    var selected = _a.selected, monthInfo = _a.monthInfo, date = _a.date, items = _a.items, onClick = _a.onClick;
    var _c = (0, react_1.useMemo)(function () { return [
        date.day === (selected === null || selected === void 0 ? void 0 : selected.day),
        date.day === monthInfo.today,
    ]; }, [selected, monthInfo, date]), active = _c[0], today = _c[1];
    var onCellClick = function () {
        onClick && onClick(date);
    };
    var onPosterClick = (0, react_1.useCallback)(function (event) {
        event.stopPropagation();
    }, []);
    var _d = (0, react_1.useState)({ x: 0, y: 0 }), tilt = _d[0], setTilt = _d[1];
    var resetTilt = function () { return setTilt({ x: 0, y: 0 }); };
    var onMouseMoveTilt = function (e) {
        var rect = e.currentTarget.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var rotateY = (px - 0.5) * 6; // tilt left/right
        var rotateX = (0.5 - py) * 6; // tilt up/down
        setTilt({ x: rotateX, y: rotateY });
    };
    return (react_1.default.createElement(framer_motion_1.motion.div, { initial: { opacity: 0, y: 10 }, animate: { opacity: 1, y: 0 }, whileHover: { scale: 1.01 }, whileTap: { scale: 0.995 }, transition: { duration: 0.25 }, style: { transformStyle: 'preserve-3d', perspective: 800, rotateX: tilt.x, rotateY: tilt.y }, onMouseMove: onMouseMoveTilt, onMouseLeave: resetTilt, onClick: onCellClick, role: 'button', tabIndex: 0, onKeyDown: function (e) { if (e.key === 'Enter' || e.key === ' ') {
            onCellClick();
        } } },
        react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Cell_less_1.default['cell'], (_b = {}, _b[Cell_less_1.default['active']] = active, _b[Cell_less_1.default['today']] = today, _b)), onClick: onCellClick },
            react_1.default.createElement("div", { className: Cell_less_1.default['heading'] },
                react_1.default.createElement("div", { className: Cell_less_1.default['day'] }, date.day)),
            react_1.default.createElement(components_1.HorizontalScroll, { className: Cell_less_1.default['items'] }, items.map(function (_a) {
                var id = _a.id, name = _a.name, poster = _a.poster, deepLinks = _a.deepLinks;
                return (react_1.default.createElement(framer_motion_1.motion.div, { key: id, whileHover: { scale: 1.04 }, whileTap: { scale: 0.98 }, transition: { duration: 0.15 } },
                    react_1.default.createElement(components_1.Button, { className: Cell_less_1.default['item'], href: deepLinks.metaDetailsStreams, tabIndex: -1, onClick: onPosterClick },
                        react_1.default.createElement(react_2.default, { className: Cell_less_1.default['icon'], name: 'play' }),
                        react_1.default.createElement(components_1.Image, { className: Cell_less_1.default['poster'], src: poster, alt: name }))));
            })),
            items.length > 0 ?
                react_1.default.createElement(react_2.default, { className: Cell_less_1.default['more'], name: 'more-horizontal' })
                :
                    null)));
};
exports.default = Cell;
